module.exports = __webpack_public_path__ + "static/sharecard-default-c8b13330e08d608b0342f6db6e687358.png";